import {remCalc} from '../_utils'

const radius = {
    null: remCalc(0),
    small: remCalc(2),
    medium: remCalc(4),
    'medium-1': remCalc(6),
    large: remCalc(8),
    'large-1': remCalc(12),
    xl: remCalc(16),
    'xl-1': remCalc(20),
    xxl: remCalc(24),
    full: remCalc(999),

    //old token for the button component, to be removed in favor of the new button token
    button: {
        base: remCalc(100),
        sm: remCalc(100),
        md: remCalc(100),
        lg: remCalc(100),
    },
}

export default radius
